<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.1369 31.0356L36.9047 14.2679L33.3691 10.7323L20.1369 23.9646L6.90467 10.7323L3.36914 14.2679L20.1369 31.0356Z"
      class="fill-current"
    />
  </svg>
</template>
